import { render } from "./Consultants.vue?vue&type=template&id=66d04e74"
import script from "./Consultants.vue?vue&type=script&lang=js"
export * from "./Consultants.vue?vue&type=script&lang=js"

import "./Consultants.vue?vue&type=style&index=0&id=66d04e74&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__